import { SurveyData } from '../services/listingsSearchCriteriaApi';
import { Listing, SearchSummary } from './types';

export class UnauthorizedError extends Error {
  constructor() {
    super('Telegram init data is missing or invalid');
    this.name = 'UnauthorizedError';
  }
}

export class MiniAppApi {
  constructor(private apiBaseUrl: string, private initData: () => string) {}

  async createSearch(criteria: SurveyData): Promise<{ id: string }> {
    return this.request('/miniapp/v1/searches', {
      method: 'POST',
      headers: { ...this.headers(), 'Content-Type': 'application/json' },
      body: JSON.stringify(criteria),
    });
  }

  async fetchSearches(): Promise<SearchSummary[]> {
    const data: { searches: SearchSummary[] } = await this.request('/miniapp/v1/searches', {
      method: 'GET',
      headers: this.headers(),
    });
    return data.searches;
  }

  async fetchListings(searchId: string, limit = 50): Promise<Listing[]> {
    const data: { listings: Listing[] } = await this.request(
      `/miniapp/v1/searches/${encodeURIComponent(searchId)}/listings?limit=${limit}`,
      { method: 'GET', headers: this.headers() },
    );
    return data.listings;
  }

  private headers(): Record<string, string> {
    return {
      'Accept': 'application/json',
      'Authorization': `tma ${this.initData()}`,
    };
  }

  private async request<T>(path: string, init: RequestInit): Promise<T> {
    const response = await fetch(`${this.apiBaseUrl}${path}`, init);

    if (response.status === 401) {
      throw new UnauthorizedError();
    }
    if (!response.ok) {
      throw new Error(`Request to ${path.split('?')[0]} failed with status ${response.status}`);
    }

    return response.json();
  }
}
